// src/components/Travel/index.tsx
import React, { useState } from 'react';
import { Container, DropdownButton, Dropdown } from 'react-bootstrap';

import GoogleMapsEmbed from './GoogleMapsEmbed';

import "./style.css";

interface CityInfo {
    title: string;
    embedID: string;
}

interface CitiesMap {
    [key: string]: CityInfo;
}

const CITIES: CitiesMap = {
    "kauai": { title: "Kauai (Hawaii), USA", embedID: "1TfnVQqej6fmtRVj9NiVAwZUQSH9Wqd0" },
    "oahu": { title: "O'ahu (Hawaii), USA", embedID: "1vwc3506KGZdnxLln6o8NZaE23h97gfQ" },
    "mexico-city": { title: "Mexico City, MX", embedID: "1CbZt6cu7YYOY3K_Yqqr_CaPhVrZ6zWcI" },
};

const buildDropdownItems = (cities: CitiesMap): React.ReactNode[] => {
    const dropdownItems: React.ReactNode[] = [];
    for (const city in cities) {
        dropdownItems.push(
            <Dropdown.Item key={city} eventKey={city}>
                {CITIES[city].title}
            </Dropdown.Item>
        );
    }
    return dropdownItems;
};

const Travel: React.FC = () => {
    const [activeKey, setActiveKey] = useState<string>("kauai");
    const [activeTitle, setActiveTitle] = useState<string>(CITIES["kauai"].title);

    const handleSelect = (selectedKey: string | null): void => {
        if (selectedKey) {
            setActiveKey(selectedKey);
            setActiveTitle(CITIES[selectedKey].title);
        }
    };

    const embedID = CITIES[activeKey].embedID;
    const body = <GoogleMapsEmbed embedID={embedID} />;

    return (
        <Container>
            <h3>Travel favorites</h3>
            <div className="travel-dropdown">
                <DropdownButton id="dropdown-basic-button" title={activeTitle} onSelect={handleSelect}> 
                    {buildDropdownItems(CITIES)}
                </DropdownButton>
            </div>
            {body}
        </Container>
    );
};

export default Travel;

